export interface Country {
    name: string;
    code: string;
    iso: string;
}

// LatAm prioritized countries + Frequently used
const latamCountries: Country[] = [
    { name: 'México', code: '52', iso: 'mx' },
    { name: 'Colombia', code: '57', iso: 'co' },
    { name: 'Argentina', code: '54', iso: 'ar' },
    { name: 'Perú', code: '51', iso: 'pe' },
    { name: 'España', code: '34', iso: 'es' },
    { name: 'Chile', code: '56', iso: 'cl' },
    { name: 'Ecuador', code: '593', iso: 'ec' },
    { name: 'Guatemala', code: '502', iso: 'gt' },
    { name: 'Bolivia', code: '591', iso: 'bo' },
    { name: 'República Dominicana', code: '1', iso: 'do' },
    { name: 'Honduras', code: '504', iso: 'hn' },
    { name: 'Paraguay', code: '595', iso: 'py' },
    { name: 'El Salvador', code: '503', iso: 'sv' },
    { name: 'Nicaragua', code: '505', iso: 'ni' },
    { name: 'Costa Rica', code: '506', iso: 'cr' },
    { name: 'Panamá', code: '507', iso: 'pa' },
    { name: 'Uruguay', code: '598', iso: 'uy' },
    { name: 'Puerto Rico', code: '1', iso: 'pr' },
    { name: 'Venezuela', code: '58', iso: 've' },
    { name: 'Cuba', code: '53', iso: 'cu' },
    { name: 'Estados Unidos', code: '1', iso: 'us' },
];

const otherCountries: Country[] = [
    { name: 'Afganistán', code: '93', iso: 'af' },
    { name: 'Albania', code: '355', iso: 'al' },
    { name: 'Alemania', code: '49', iso: 'de' },
    { name: 'Andorra', code: '376', iso: 'ad' },
    { name: 'Angola', code: '244', iso: 'ao' },
    { name: 'Anguila', code: '1264', iso: 'ai' },
    { name: 'Antártida', code: '672', iso: 'aq' },
    { name: 'Antigua y Barbuda', code: '1268', iso: 'ag' },
    { name: 'Arabia Saudita', code: '966', iso: 'sa' },
    { name: 'Argelia', code: '213', iso: 'dz' },
    { name: 'Armenia', code: '374', iso: 'am' },
    { name: 'Aruba', code: '297', iso: 'aw' },
    { name: 'Australia', code: '61', iso: 'au' },
    { name: 'Austria', code: '43', iso: 'at' },
    { name: 'Azerbaiyán', code: '994', iso: 'az' },
    { name: 'Bahamas', code: '1242', iso: 'bs' },
    { name: 'Bangladés', code: '880', iso: 'bd' },
    { name: 'Barbados', code: '1246', iso: 'bb' },
    { name: 'Baréin', code: '973', iso: 'bh' },
    { name: 'Bélgica', code: '32', iso: 'be' },
    { name: 'Belice', code: '501', iso: 'bz' },
    { name: 'Benín', code: '229', iso: 'bj' },
    { name: 'Bermudas', code: '1441', iso: 'bm' },
    { name: 'Bielorrusia', code: '375', iso: 'by' },
    { name: 'Bosnia y Herzegovina', code: '387', iso: 'ba' },
    { name: 'Botsuana', code: '267', iso: 'bw' },
    { name: 'Brasil', code: '55', iso: 'br' },
    { name: 'Brunéi', code: '673', iso: 'bn' },
    { name: 'Bulgaria', code: '359', iso: 'bg' },
    { name: 'Burkina Faso', code: '226', iso: 'bf' },
    { name: 'Burundi', code: '257', iso: 'bi' },
    { name: 'Bután', code: '975', iso: 'bt' },
    { name: 'Cabo Verde', code: '238', iso: 'cv' },
    { name: 'Camboya', code: '855', iso: 'kh' },
    { name: 'Camerún', code: '237', iso: 'cm' },
    { name: 'Canadá', code: '1', iso: 'ca' },
    { name: 'Catar', code: '974', iso: 'qa' },
    { name: 'Chad', code: '235', iso: 'td' },
    { name: 'China', code: '86', iso: 'cn' },
    { name: 'Chipre', code: '357', iso: 'cy' },
    { name: 'Comoras', code: '269', iso: 'km' },
    { name: 'Corea del Norte', code: '850', iso: 'kp' },
    { name: 'Corea del Sur', code: '82', iso: 'kr' },
    { name: 'Costa de Marfil', code: '225', iso: 'ci' },
    { name: 'Croacia', code: '385', iso: 'hr' },
    { name: 'Curazao', code: '599', iso: 'cw' },
    { name: 'Dinamarca', code: '45', iso: 'dk' },
    { name: 'Dominica', code: '1767', iso: 'dm' },
    { name: 'Egipto', code: '20', iso: 'eg' },
    { name: 'Emiratos Árabes Unidos', code: '971', iso: 'ae' },
    { name: 'Eritrea', code: '291', iso: 'er' },
    { name: 'Eslovaquia', code: '421', iso: 'sk' },
    { name: 'Eslovenia', code: '386', iso: 'si' },
    { name: 'Estonia', code: '372', iso: 'ee' },
    { name: 'Etiopía', code: '251', iso: 'et' },
    { name: 'Filipinas', code: '63', iso: 'ph' },
    { name: 'Finlandia', code: '358', iso: 'fi' },
    { name: 'Fiyi', code: '679', iso: 'fj' },
    { name: 'Francia', code: '33', iso: 'fr' },
    { name: 'Gabón', code: '241', iso: 'ga' },
    { name: 'Gambia', code: '220', iso: 'gm' },
    { name: 'Georgia', code: '995', iso: 'ge' },
    { name: 'Ghana', code: '233', iso: 'gh' },
    { name: 'Gibraltar', code: '350', iso: 'gi' },
    { name: 'Granada', code: '1473', iso: 'gd' },
    { name: 'Grecia', code: '30', iso: 'gr' },
    { name: 'Groenlandia', code: '299', iso: 'gl' },
    { name: 'Guadalupe', code: '590', iso: 'gp' },
    { name: 'Guam', code: '1671', iso: 'gu' },
    { name: 'Guayana Francesa', code: '594', iso: 'gf' },
    { name: 'Guernsey', code: '44', iso: 'gg' },
    { name: 'Guinea', code: '224', iso: 'gn' },
    { name: 'Guinea-Bisáu', code: '245', iso: 'gw' },
    { name: 'Guinea Ecuatorial', code: '240', iso: 'gq' },
    { name: 'Guyana', code: '592', iso: 'gy' },
    { name: 'Haití', code: '509', iso: 'ht' },
    { name: 'Hong Kong', code: '852', iso: 'hk' },
    { name: 'Hungría', code: '36', iso: 'hu' },
    { name: 'India', code: '91', iso: 'in' },
    { name: 'Indonesia', code: '62', iso: 'id' },
    { name: 'Irak', code: '964', iso: 'iq' },
    { name: 'Irán', code: '98', iso: 'ir' },
    { name: 'Irlanda', code: '353', iso: 'ie' },
    { name: 'Isla de Man', code: '44', iso: 'im' },
    { name: 'Isla Norfolk', code: '672', iso: 'nf' },
    { name: 'Islandia', code: '354', iso: 'is' },
    { name: 'Islas Caimán', code: '1345', iso: 'ky' },
    { name: 'Islas Cocos', code: '61', iso: 'cc' },
    { name: 'Islas Cook', code: '682', iso: 'ck' },
    { name: 'Islas Feroe', code: '298', iso: 'fo' },
    { name: 'Islas Malvinas', code: '500', iso: 'fk' },
    { name: 'Islas Marianas del Norte', code: '1670', iso: 'mp' },
    { name: 'Islas Marshall', code: '692', iso: 'mh' },
    { name: 'Islas Salomón', code: '677', iso: 'sb' },
    { name: 'Islas Turcas y Caicos', code: '1649', iso: 'tc' },
    { name: 'Islas Vírgenes Británicas', code: '1284', iso: 'vg' },
    { name: 'Islas Vírgenes de los Estados Unidos', code: '1340', iso: 'vi' },
    { name: 'Israel', code: '972', iso: 'il' },
    { name: 'Italia', code: '39', iso: 'it' },
    { name: 'Jamaica', code: '1876', iso: 'jm' },
    { name: 'Japón', code: '81', iso: 'jp' },
    { name: 'Jersey', code: '44', iso: 'je' },
    { name: 'Jordania', code: '962', iso: 'jo' },
    { name: 'Kazajistán', code: '7', iso: 'kz' },
    { name: 'Kenia', code: '254', iso: 'ke' },
    { name: 'Kirguistán', code: '996', iso: 'kg' },
    { name: 'Kiribati', code: '686', iso: 'ki' },
    { name: 'Kuwait', code: '965', iso: 'kw' },
    { name: 'Laos', code: '856', iso: 'la' },
    { name: 'Lesoto', code: '266', iso: 'ls' },
    { name: 'Letonia', code: '371', iso: 'lv' },
    { name: 'Líbano', code: '961', iso: 'lb' },
    { name: 'Liberia', code: '231', iso: 'lr' },
    { name: 'Libia', code: '218', iso: 'ly' },
    { name: 'Liechtenstein', code: '423', iso: 'li' },
    { name: 'Lituania', code: '370', iso: 'lt' },
    { name: 'Luxemburgo', code: '352', iso: 'lu' },
    { name: 'Macao', code: '853', iso: 'mo' },
    { name: 'Macedonia del Norte', code: '389', iso: 'mk' },
    { name: 'Madagascar', code: '261', iso: 'mg' },
    { name: 'Malasia', code: '60', iso: 'my' },
    { name: 'Malaui', code: '265', iso: 'mw' },
    { name: 'Maldivas', code: '960', iso: 'mv' },
    { name: 'Malí', code: '223', iso: 'ml' },
    { name: 'Malta', code: '356', iso: 'mt' },
    { name: 'Marruecos', code: '212', iso: 'ma' },
    { name: 'Martinica', code: '596', iso: 'mq' },
    { name: 'Mauricio', code: '230', iso: 'mu' },
    { name: 'Mauritania', code: '222', iso: 'mr' },
    { name: 'Mayotte', code: '262', iso: 'yt' },
    { name: 'Micronesia', code: '691', iso: 'fm' },
    { name: 'Moldavia', code: '373', iso: 'md' },
    { name: 'Mónaco', code: '377', iso: 'mc' },
    { name: 'Mongolia', code: '976', iso: 'mn' },
    { name: 'Montenegro', code: '382', iso: 'me' },
    { name: 'Montserrat', code: '1664', iso: 'ms' },
    { name: 'Mozambique', code: '258', iso: 'mz' },
    { name: 'Myanmar', code: '95', iso: 'mm' },
    { name: 'Namibia', code: '264', iso: 'na' },
    { name: 'Nauru', code: '674', iso: 'nr' },
    { name: 'Nepal', code: '977', iso: 'np' },
    { name: 'Níger', code: '227', iso: 'ne' },
    { name: 'Nigeria', code: '234', iso: 'ng' },
    { name: 'Niue', code: '683', iso: 'nu' },
    { name: 'Noruega', code: '47', iso: 'no' },
    { name: 'Nueva Caledonia', code: '687', iso: 'nc' },
    { name: 'Nueva Zelanda', code: '64', iso: 'nz' },
    { name: 'Omán', code: '968', iso: 'om' },
    { name: 'Países Bajos', code: '31', iso: 'nl' },
    { name: 'Paquistán', code: '92', iso: 'pk' },
    { name: 'Palaos', code: '680', iso: 'pw' },
    { name: 'Papúa Nueva Guinea', code: '675', iso: 'pg' },
    { name: 'Polinesia Francesa', code: '689', iso: 'pf' },
    { name: 'Polonia', code: '48', iso: 'pl' },
    { name: 'Portugal', code: '351', iso: 'pt' },
    { name: 'Reino Unido', code: '44', iso: 'gb' },
    { name: 'República Centroafricana', code: '236', iso: 'cf' },
    { name: 'República Checa', code: '420', iso: 'cz' },
    { name: 'República del Congo', code: '242', iso: 'cg' },
    { name: 'República Democrática del Congo', code: '243', iso: 'cd' },
    { name: 'Reunión', code: '262', iso: 're' },
    { name: 'Rumania', code: '40', iso: 'ro' },
    { name: 'Rusia', code: '7', iso: 'ru' },
    { name: 'Ruanda', code: '250', iso: 'rw' },
    { name: 'Sáhara Occidental', code: '212', iso: 'eh' },
    { name: 'Samoa', code: '685', iso: 'ws' },
    { name: 'Samoa Americana', code: '1684', iso: 'as' },
    { name: 'San Bartolomé', code: '590', iso: 'bl' },
    { name: 'San Cristóbal y Nieves', code: '1869', iso: 'kn' },
    { name: 'San Marino', code: '378', iso: 'sm' },
    { name: 'San Martín', code: '590', iso: 'mf' },
    { name: 'San Pedro y Miquelón', code: '508', iso: 'pm' },
    { name: 'San Vicente y las Granadinas', code: '1784', iso: 'vc' },
    { name: 'Santa Elena', code: '290', iso: 'sh' },
    { name: 'Santa Lucía', code: '1758', iso: 'lc' },
    { name: 'Santo Tomé y Príncipe', code: '239', iso: 'st' },
    { name: 'Senegal', code: '221', iso: 'sn' },
    { name: 'Serbia', code: '381', iso: 'rs' },
    { name: 'Seychelles', code: '248', iso: 'sc' },
    { name: 'Sierra Leona', code: '232', iso: 'sl' },
    { name: 'Singapur', code: '65', iso: 'sg' },
    { name: 'Sint Maarten', code: '1721', iso: 'sx' },
    { name: 'Siria', code: '963', iso: 'sy' },
    { name: 'Somalia', code: '252', iso: 'so' },
    { name: 'Sri Lanka', code: '94', iso: 'lk' },
    { name: 'Sudáfrica', code: '27', iso: 'za' },
    { name: 'Sudán', code: '249', iso: 'sd' },
    { name: 'Sudán del Sur', code: '211', iso: 'ss' },
    { name: 'Suecia', code: '46', iso: 'se' },
    { name: 'Suiza', code: '41', iso: 'ch' },
    { name: 'Surinam', code: '597', iso: 'sr' },
    { name: 'Tailandia', code: '66', iso: 'th' },
    { name: 'Taiwán', code: '886', iso: 'tw' },
    { name: 'Tanzania', code: '255', iso: 'tz' },
    { name: 'Tayikistán', code: '992', iso: 'tj' },
    { name: 'Territorio Británico del Océano Índico', code: '246', iso: 'io' },
    { name: 'Timor Oriental', code: '670', iso: 'tl' },
    { name: 'Togo', code: '228', iso: 'tg' },
    { name: 'Tokelau', code: '690', iso: 'tk' },
    { name: 'Tonga', code: '676', iso: 'to' },
    { name: 'Trinidad y Tobago', code: '1868', iso: 'tt' },
    { name: 'Túnez', code: '216', iso: 'tn' },
    { name: 'Turkmenistán', code: '993', iso: 'tm' },
    { name: 'Turquía', code: '90', iso: 'tr' },
    { name: 'Tuvalu', code: '688', iso: 'tv' },
    { name: 'Ucrania', code: '380', iso: 'ua' },
    { name: 'Uganda', code: '256', iso: 'ug' },
    { name: 'Uzbekistán', code: '998', iso: 'uz' },
    { name: 'Vanuatu', code: '678', iso: 'vu' },
    { name: 'Vaticano', code: '379', iso: 'va' },
    { name: 'Vietnam', code: '84', iso: 'vn' },
    { name: 'Wallis y Futuna', code: '681', iso: 'wf' },
    { name: 'Yemen', code: '967', iso: 'ye' },
    { name: 'Yibuti', code: '253', iso: 'dj' },
    { name: 'Zambia', code: '260', iso: 'zm' },
    { name: 'Zimbabue', code: '263', iso: 'zw' }
];

export const countries: Country[] = [...latamCountries, ...otherCountries];
